<template>
<div class="curve-ma-in-operate" id="page">
  <el-row class="row-start-between">
    <el-form :model="form" class="row-center-start" ref="formRef">
      <el-row>
        <el-form-item prop="txtLxcgCurveGroupName">
          <el-input v-model="form.txtLxcgCurveGroupName" clearable placeholder="曲线组名称">
            <template #prepend>
              <i class="iconfont icon-sousuo" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="dateRange">
          <el-date-picker value-format="YYYY-MM-DD" v-model="form.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">搜索</el-button>
          <el-button type="info" @click="reset()">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row>
      <el-button type="primary" @click="dialog.updateShow=true">新增曲线组</el-button>
    </el-row>
  </el-row>
  <el-table :data="table.tableData" v-loading="table.tabelLoading">
    <el-table-column prop="txtLxcgCurveGroupName" label="曲线组名称" :show-overflow-tooltip="true" align="center">
      <template #default="scope">{{scope.row.txtLxcgCurveGroupName||"- -"}}</template>
    </el-table-column>
    <el-table-column prop="txtLxcgCurveGroupDesc" label="曲线组说明" align="center">
      <template #default="scope">
        <template v-if="scope.row.txtLxcgCurveGroupDesc.length>40">
          <el-tooltip class="box-item" effect="dark" :content="scope.row.txtLxcgCurveGroupDesc.slice(0, 80)+'...'" placement="top">
            {{ scope.row.txtLxcgCurveGroupDesc.slice(0, 40) + "..." }}
          </el-tooltip>
        </template>
        <template v-else>{{ scope.row.txtLxcgCurveGroupDesc||"- -" }}</template>
      </template>
    </el-table-column>
    <el-table-column prop="dtCreate" label="创建时间" align="center">
      <template #default="scope">{{scope.row.dtCreate||"- -"}}</template>
    </el-table-column>
    <el-table-column label="操作" align="center" class-name="table-option" width="150">
      <template #default="scope">
        <div class="table-icon" @click="handleEdit(scope.row)">
          <el-icon>
            <EditPen />
          </el-icon> 编辑
        </div>
        <div class="table-icon" @click="handleDelete(scope.row)">
          <el-icon>
            <Delete />
          </el-icon> 删除
        </div>
      </template>
    </el-table-column>
  </el-table>
  <pagination :total="table.total" @sizeChange="(e) => {form.limit=e;getList()}" @pageChange="(e) => {form.page=e;getList()}" />
  <update-curve v-if="dialog.updateShow" :updateData="dialog.updateData" @close="(e) => {dialog.updateData={type:'add'};dialog.updateShow=false;if(e){getList()}}" />
</div>
</template>

<script>
// 运营管理 - 曲线组管理
import { useStore } from 'vuex';
import { Pagination } from "components";
import { onMounted, reactive, toRefs } from 'vue';
import UpdateCurve from "./comp/curve/updateCurve.vue";
import { ElMessage, ElMessageBox, } from "element-plus";
import { EditPen, Delete } from "@element-plus/icons-vue";
import { getCurveListByPage, deleteCurveVersion } from "api/apis.js";
export default {
  components: {
    Pagination,
    UpdateCurve,
    EditPen,
    Delete,
  },
  setup() {
    const store = useStore();
    const state = reactive({
      form: {
        txtLxcgCurveGroupName: "",
        dateRange: [],
        limit: 10,
        page: 1
      },
      table: {
        tableData: [],
        total: 0,
        tabelLoading: false
      },
      dialog: {
        updateShow: false,
        updateData: { type: "add" }
      }
    });

    onMounted(() => {
      getList();
    })

    // 编辑曲线组
    const handleEdit = row => {
      row.type = "edit";
      state.dialog.updateData = row;
      state.dialog.updateShow = true;
    };

    // 删除曲线组
    const handleDelete = row => {
      // 删除前判断
      // 是否存在已配置的曲线
      if (row.hasCurve) {
        ElMessageBox.confirm(
          "仍存在已配置的曲线，不可删除",
          '提示', {
            showCancelButton: false,
            confirmButtonText: '确定'
          }
        ).then(() => {})
      } else if (row.hasHardwareVersion) {
        // 是否存在关联的硬件版本
        ElMessageBox.confirm(
          "仍存在关联的硬件版本，不可删除",
          '提示', {
            showCancelButton: false,
            confirmButtonText: '确定'
          }
        ).then(() => {})
      } else {
        // 啥都没有 二次确认，调用删除接口
        ElMessageBox.confirm(
          `请确认是否删除当前【${row.txtLxcgCurveGroupName}】曲线组？`,
          '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定'
          }
        ).then(() => {
          state.table.tabelLoading = true;
          deleteCurveVersion({
            lxcgCurveGroupId: row.lxcgCurveGroupId,
            txtUpdater: store.getters.userInfo ? store.getters.userInfo.name : "系统用户"
          }).then(res => {
            if (res.code == 200) {
              ElMessage.success("删除成功");
              getList();
            } else {
              ElMessage.error(res.message);
            }
          }).catch(e => {
            console.error(e);
          }).finally(() => {
            state.table.tabelLoading = false;
          })
        }).catch(() => {
          // 取消删除
        })
      }
    };

    // 获取列表数据
    const getList = () => {
      state.table.tabelLoading = true;
      let param = {
        pageNum: state.form.page,
        pageSize: state.form.limit,
        query: {
          txtLxcgCurveGroupName: state.form.txtLxcgCurveGroupName,
          dtFrom: (state.form.dateRange || []).length == 0 ? "" : state.form.dateRange[0],
          dtTo: (state.form.dateRange || []).length == 0 ? "" : state.form.dateRange[1]
        }
      }
      getCurveListByPage(param).then(response => {
        if (response.code == 200) {
          state.table.tableData = response.data.list;
          state.table.total = response.data.total;
        } else {
          state.table.tableData = response.data.list;
          state.table.total = response.data.total;
          ElMessage.error(response.message);
        }
      }).catch(e => {
        console.error(e);
      }).finally(() => {
        state.table.tabelLoading = false;
      })
    };

    // 重置表单
    const reset = () => {
      state.form = {
        txtLxcgCurveGroupName: "",
        dateRange: [],
        limit: 10,
        page: 1
      }
      getList();
    };

    return {
      ...toRefs(state),
      getList,
      reset,
      handleEdit,
      handleDelete
    }
  }
}
</script>

<style lang="scss" scoped>
.curve-ma-in-operate {
  .el-table {
    height: calc(100% - 95px);
  }
}
</style>
